import { isArray } from 'util';
import { ManufacturingOrderFeature } from '../manufacturing-order-feature';

export class ManufacturingOrderFeatureBuilder {
  static fromJson(json) {
    return (json)
      ? new ManufacturingOrderFeature(
        json.hash,
        json.name
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ManufacturingOrderFeatureBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/manufacturing-order-feature.builder.ts